import{b as t}from"./chunk-SPRNSFUV.mjs";var o=n=>typeof n=="string"?t.isValid(n).valid?n:new TextEncoder().encode(n):n;export{o as a};
//# sourceMappingURL=chunk-5B3SMBXQ.mjs.map